import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc1452bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weather-box" }
const _hoisted_2 = { class: "weather" }
const _hoisted_3 = { class: "weather-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/sk/skImage/weather/logo.png",
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "weather-left" }
const _hoisted_6 = { class: "b-time" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "北京时间", -1))
const _hoisted_8 = { class: "b-time" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首尔时间", -1))
const _hoisted_10 = { class: "weather-detail" }
const _hoisted_11 = { class: "d-top" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "d-bottom" }
const _hoisted_14 = { class: "env-box" }
const _hoisted_15 = { class: "env-item env-box-bg" }
const _hoisted_16 = { class: "env-icon" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "温度", -1))
const _hoisted_19 = { class: "env-text" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "env-rate" }, "℃", -1))
const _hoisted_21 = { class: "env-item env-box-bg" }
const _hoisted_22 = { class: "env-icon" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "湿度", -1))
const _hoisted_25 = { class: "env-text" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "env-rate" }, "%", -1))
const _hoisted_27 = { class: "env-item env-box-bg" }
const _hoisted_28 = { class: "env-icon" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "甲醛", -1))
const _hoisted_31 = { class: "env-text" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "env-rate" }, "mg/m³", -1))
const _hoisted_33 = { class: "env-item env-box-bg" }
const _hoisted_34 = { class: "env-icon" }
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PM2.5", -1))
const _hoisted_37 = { class: "env-text" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "env-rate" }, "ug/m³", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sunny = _resolveComponent("sunny")!
  const _component_ran = _resolveComponent("ran")!
  const _component_snow = _resolveComponent("snow")!
  const _component_clound = _resolveComponent("clound")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.weatherKey == 'sunny')
      ? (_openBlock(), _createBlock(_component_sunny, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.weatherKey == 'rain')
      ? (_openBlock(), _createBlock(_component_ran, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.weatherKey == 'snow')
      ? (_openBlock(), _createBlock(_component_snow, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.weatherKey == 'clound')
      ? (_openBlock(), _createBlock(_component_clound, { key: 3 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.nowTime), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_ctx.sTime), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: '/sk/skImage/weather/' + _ctx.logonIcon,
                alt: ""
              }, null, 8, _hoisted_12),
              _createElementVNode("span", null, _toDisplayString(_ctx.temperature) + " ℃", 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, _toDisplayString(_ctx.nowDate), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.week), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              src: 
                _ctx.weatherKey == 'sunny'
                  ? '/sk/skImage/weather/温度.png'
                  : '/sk/skImage/weather/温度.png'
              ,
              alt: ""
            }, null, 8, _hoisted_17),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.envObj.Tdb), 1),
          _hoisted_20
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("img", {
              src: 
                _ctx.weatherKey == 'sunny'
                  ? '/sk/skImage/weather/湿度.png'
                  : '/sk/skImage/weather/湿度.png'
              ,
              alt: ""
            }, null, 8, _hoisted_23),
            _hoisted_24
          ]),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.envObj.RH), 1),
          _hoisted_26
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("img", {
              src: 
                _ctx.weatherKey == 'sunny'
                  ? '/sk/skImage/weather/甲醛.png'
                  : '/sk/skImage/weather/甲醛.png'
              ,
              alt: ""
            }, null, 8, _hoisted_29),
            _hoisted_30
          ]),
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.envObj.HCHO), 1),
          _hoisted_32
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("img", {
              src: 
                _ctx.weatherKey == 'sunny'
                  ? '/sk/skImage/weather/pm.png'
                  : '/sk/skImage/weather/pm.png'
              ,
              alt: ""
            }, null, 8, _hoisted_35),
            _hoisted_36
          ]),
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.envObj.PM2d5), 1),
          _hoisted_38
        ])
      ])
    ])
  ]))
}